var map = {
	"./json/version": 357,
	"./json/version.json": 357
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;



/*****************
 ** WEBPACK FOOTER
 ** ./moveToDist ^\.\/.*$
 ** module id = 10
 ** module chunks = 0
 **/